import { useMemo, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { CalendarWorkout } from '../../services/api';
import { CalendarPerformanceChart } from './CalendarPerformanceChart';

export function CalendarDurationLink({ workouts, children }: { workouts: CalendarWorkout[]; children: ReactNode }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const distribution = useMemo(() => {
    const totals = new Map<string, number>();
    const seen = new Set<number>();
    for (const workout of workouts) {
      if (seen.has(workout.id) || Number(workout.workout_type?.id) === 7) continue;
      seen.add(workout.id);
      const name = (workout.workout_type?.english_name ?? workout.workout_type?.name ?? '').toLowerCase();
      const sport = /cycl|bike|دوچرخه/.test(name) ? 'bike' : /run|دویدن/.test(name) ? 'run'
        : /swim|شنا/.test(name) ? 'swim' : /strength|weight|gym|bodybuild|بدنسازی|قدرتی/.test(name) ? 'strength' : 'other';
      const seconds = Number(workout.total_time ?? workout.total_time_planned);
      if (Number.isFinite(seconds) && seconds > 0) totals.set(sport, (totals.get(sport) ?? 0) + seconds);
    }
    return [...totals].map(([label, value]) => ({ label, value }));
  }, [workouts]);
  return <><a className="calendar-duration-link" href="#calendar-duration-chart" aria-haspopup="dialog" title={t('sportDuration.title')}
    onClick={event => { event.preventDefault(); setOpen(true); }}>{children}</a>
    {open && <CalendarPerformanceChart userId={null} durationData={distribution} onClose={() => setOpen(false)} />}
  </>;
}
